<app-nav></app-nav>
<div class="div" style="height: 200px;"></div>
<div style="text-align: center; ">
    <h1 translate="evisa-video">eVisa Video</h1>
    <p translate="choose-video">Choose videos from YouTube or Ixigua</p>
</div>

<div class="container">
    <!-- YouTube Section -->
    <div class="section" style="text-align: center;">
        <h3 translate="youtube-video" style="margin-bottom: 40px;">YouTube Videos</h3>
        <a href="https://www.youtube.com/watch?v=xF7hn7PGnqo" target="_blank" class="btn youtube">
            <img src="assets/images/play-button-arrowhead.png" alt="YouTube Logo" class="youtube-logo" width="20"
                height="20">
            <span style="margin: 3px 10px;" translate="youtube-link-en">YouTube Video (English)</span>
            <img src="assets/images/external-link.png" alt="External Link" class="external-link-icon" width="20"
                height="20">
        </a>
        <a href="https://www.youtube.com/watch?v=ahO4fvWdxFA" target="_blank" class="btn youtube">
            <img src="assets/images/play-button-arrowhead.png" alt="YouTube Logo" class="youtube-logo" width="20" />
            <span style="margin: 3px 10px;" translate="youtube-link-cn">YouTube Video (Chinese)</span>
            <img src="assets/images/external-link.png" alt="External Link" class="external-link-icon" width="20"
                height="20">
        </a>
    </div>

    <!-- Ixigua Section -->
    <div class="section" style="text-align: center;">
        <h3 translate="ixigua-video" style="margin-bottom: 40px;">Ixigua Videos</h3>
        <a href="https://m.ixigua.com/video/7231464394629055037" target="_blank" class="btn ixigua">
            <img src="assets/images/play-button-arrowhead.png" alt="YouTube Logo" class="youtube-logo" width="20"
                height="20">
            <span style="margin: 3px 10px;" translate="ixigua-link-cn">Ixigua Video
                (Chinese)</span>
            <img src="assets/images/external-link.png" alt="External Link" class="external-link-icon" width="20"
                height="20">
        </a>
        <a href="https://m.ixigua.com/video/7232126762157933060" target="_blank" class="btn ixigua">
            <img src="assets/images/play-button-arrowhead.png" alt="YouTube Logo" class="youtube-logo" width="20"
                height="20">
            <span style="margin: 3px 10px;" translate="ixigua-link-en">Ixigua Video
                (English)</span>

            <img src="assets/images/external-link.png" alt="External Link" class="external-link-icon" width="20"
                height="20">
        </a>
    </div>
</div>

<app-footer></app-footer>
